BackToTop =
  render: ->
    return unless showBackToTop()

    $(window).on 'scroll', ->
      scrollTop = findScrollTop()

      if scrollTop > 100
        $('#back-to-top').fadeIn()
      else
        $('#back-to-top').fadeOut()

    $('#back-to-top').on 'click', ->
      $('body,html').animate({ scrollTop: 0}, 500)

findScrollTop = ->
  return $(window).scrollTop() if $(window).scrollTop() > 0
  return document.documentElement.scrollTop if document.documentElement.scrollTop > 0
  0

showBackToTop = ->
  $('#back-to-top').length > 0

module.exports = BackToTop
